export default "__VITE_ASSET__6792f794__$_?react__"